import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@homeleite/arch';
import { AdminGuard } from '../../core/guards/admin.guard';
import { IntegrationMonitorComponent } from './integration-monitor.component';

const routes: Routes = [
    {
        path: 'integration-monitor',
        component: IntegrationMonitorComponent,
        canActivate: [AuthGuard, AdminGuard],
        data: { title: 'Home Leite - Monitoramento de Integração' }
    }
];

export const IntegrationMonitorRoutes = RouterModule.forChild(routes);
